import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { List } from "../../components/List";
import { Links, LinksProps } from "../../components/Links";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { GenericListProps } from "../../types/GenericListType";
import { GroupedComponents } from "../../components/GroupedComponents";

export interface GasDisconnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
  linksList?: LinksProps[];
  responsibilities?: ResponsibilitiesProps[];
}

export const GasDisconnectionPage: React.FC<GasDisconnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  applyButton,
  faqs,
  linksList,
  responsibilities,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      <GroupedComponents>
        {lists && lists[1] && <List {...lists[1]} />}
        {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
      </GroupedComponents>
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {lists && lists[2] && <List {...lists[2]} />}
      {applyButton && <LinkButton {...applyButton} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
